import { Dispatch } from 'redux';

import {
  VolopFunctions,
  fetchVolopFunctions as apiFetchVolopFunctions,
} from 'api/orgs';

import { setError } from './error';

// Types

export type MainStoreVolopFunctionsState = VolopFunctions | null | undefined;

export type MainStoreVolopFunctionsAction = {
  type: 'VOLOP_FUNCTIONS_SET';
  volopFunctions: VolopFunctions | null | undefined;
};

// Reducer

export function volopFunctionsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreVolopFunctionsState = null,
  action: MainStoreVolopFunctionsAction
) {
  switch (action.type) {
    case 'VOLOP_FUNCTIONS_SET': {
      return action.volopFunctions;
    }

    default:
      return state;
  }
}

// Actions

export const fetchVolopFunctions =
  () =>
  (
    dispatch: Dispatch<MainStoreVolopFunctionsAction>,
    getState: () => { volopFunctions: MainStoreVolopFunctionsState }
  ) => {
    if (getState().volopFunctions) {
      return;
    }

    apiFetchVolopFunctions()
      .then((volopFunctions) => {
        dispatch({
          type: 'VOLOP_FUNCTIONS_SET',
          volopFunctions,
        });
      })
      .catch(setError);
  };
